export default "__VITE_ASSET__CssuIWBY__"